var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"title":"Seleccionar Mesa","hide-footer":"","size":"lg","id":"select-mesa"}},[_c('salon',{attrs:{"modo":"seleccionar-mesa","salon":_vm.salon},on:{"seleccionarMesa":_vm.seleccionarMesa}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }